import type { GarageProperty } from "@App/apis/graphql/perimeterSearch/responses/garageProperty";
import { IconLabel } from "@App/Components/atoms/common/IconLabel";
import { CheckIcon } from "@App/Components/common/Icons";
import { safeFilter } from "@App/utils/array";
import { eligibleGarageProperties } from "@App/utils/garages/eligibleGaragePropertiesUtil";
import type React from "react";

type Props = {
  garageProperties?: GarageProperty[];
  availableGarageProperties?: GarageProperty[];
};

export const GaragePropertiesList: React.FC<Props> = ({
  garageProperties,
  availableGarageProperties,
}) => {
  return (
    <>
      {safeFilter<GarageProperty>(
        eligibleGarageProperties(garageProperties, availableGarageProperties),
        (property) => property.show_in_list,
      ).map((property) => {
        if (!availableGarageProperties?.some((p) => p.id === property.id)) return null;
        return (
          <IconLabel
            key={property.id}
            icon={<CheckIcon primary />}
            text={property.list_text ?? ""}
          />
        );
      })}
    </>
  );
};
